import type * as React from "react";

import styles from "./TargetCard.module.css";

/**
 * One of a stored trigger's targets, read-only: an optional position pill, its
 * type, what it acts on, then its facts.
 */
export function TargetCard({
  pill,
  type,
  name,
  children,
  ...props
}: {
  pill?: string;
  type: string;
  name: React.ReactNode;
  children: React.ReactNode;
} & Omit<React.ComponentPropsWithoutRef<"div">, "children">) {
  return (
    <div {...props} className={styles.card}>
      <div className={styles.header}>
        {pill !== undefined && <span className={styles.pill}>{pill}</span>}
        <span className={styles.type}>{type}</span>
        {name}
      </div>
      {children}
    </div>
  );
}

/** The name in a {@link TargetCard}'s header. */
export function TargetCardName({ children }: { children: React.ReactNode }) {
  return <span className={styles.name}>{children}</span>;
}
